/** Публичный URL сайта (canonical, Open Graph). Переопределение: REACT_APP_SITE_URL */
const raw =
  (typeof process !== "undefined" && process.env.REACT_APP_SITE_URL) ||
  "https://bay-sport.ru";

export const SITE_ORIGIN = String(raw).replace(/\/$/, "");

export const SITE_NAME = "Бай.Спорт";

export const DEFAULT_DESCRIPTION =
  "Бай.Спорт — CRM для спортивных клубов и тренеров: клиенты, группы, журнал посещаемости, абонементы, соцсеть участников и PWA на телефоне.";
